module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/icn-pc-429380ad98d3fd4efd07d40770b0830e.svg";